<template>
    <v-layout column>
      <v-card class="mx-10 intro-dark align-center justify-center">
        <v-card-title class="justify-center prompt-header py-3">
          <mrx-translation :token="prompt"></mrx-translation>
        </v-card-title>

        <multiselect
          class="mb-4"
          v-model="languages"
          panelName="language"
          panelType="select"
          :onClick="set"
          >
        </multiselect>
      </v-card>
    </v-layout>
</template>

<script>
  import MultiSelect from '@/components/inputs/MultiSelect';
  import languageLogic from '@/mixins/languageLogic'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'Language',
    mixins: [languageLogic],
    components: {
      multiselect: MultiSelect,
    },
    data() {
      return {
        prompt: 'questions.language.prompt'
      }
    },
    computed: {
      languages() {
        return this.all.map(x => {
          x.selected = x.value === this.$store.state.v4.language.selected
          return x
        })
      },
      ...mapGetters({ all: 'v4/language/all' })
    },
    methods: {
      ...mapActions({ set: 'v4/language/set' })
    },
    mounted() {
      this.set(this.$store.state.v4.language.selected)
    }
  }
</script>

<style scoped>
</style>
